import { createSetFinanceDataAction } from "../actions/dataActions";
import { useGetAndSet } from "./useGetAndSet";

export const useFinanceData = params => {
  return useGetAndSet("financeagreements", params, createSetFinanceDataAction);
};
